import { MutationTree } from 'vuex';
import { initialState, OptionsSuiviInterventionState } from './state';
import { OPTIONS_SUIVI } from '@/modules/OptionsSuiviInterventions/store/mutation-types';

export const mutations: MutationTree<OptionsSuiviInterventionState> = {
    [OPTIONS_SUIVI.SET_MODAL](state, isOpen: boolean) {
        state.isModaleOpen = isOpen;
    },
    [OPTIONS_SUIVI.SET_EMAIL](state, email: string) {
        state.newEmail = email;
    },
    [OPTIONS_SUIVI.RESET](state) {
        Object.assign(state, initialState);
    },
};
